import type { IMetricControl } from '~/modules/page-analytic/types';
import type { EMetricKey } from '~/types/metric';

import { IncreasePercentage, isReversePageAnalyticMetric } from '~/modules/analytics';
import { BlockStack, InlineStack, Text } from '@shopify/polaris';

export interface PAPercentProps extends IMetricControl {
  hideComparison?: boolean;
  metricKey: EMetricKey;
}

export const PAPercent = ({ value, change, hideComparison, metricKey }: PAPercentProps) => {
  return (
    <BlockStack gap="200">
      <InlineStack blockAlign="center" gap="200">
        <InlineStack blockAlign="center" gap="200">
          <Text as="span" variant="headingSm">
            {value}
          </Text>
        </InlineStack>
        {!hideComparison && (
          <IncreasePercentage
            increase={change}
            isReverse={isReversePageAnalyticMetric(metricKey)}
          />
        )}
      </InlineStack>
    </BlockStack>
  );
};
